import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/login/login'
import Home from '../components/plHome'
import OuterChain from '../components/outerChain'

Vue.use(Router)


const router = new Router({
    //  mode: 'history',
    routes: [{
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                auth: true,
            }
        },
        {
            path: '/OuterChain',
            name: 'OuterChain',
            component: OuterChain,
        }
    ]
});

router.beforeEach((to, from, next) => {
    let token = $.cookie("token");
    var item = undefined
    if (token != undefined) {
        plDataInterface.baseURL = process.env.API_HOST;
        plOtherDataInterface.baseURL = process.env.API_HOST;
        plDataInterface.Token = token;
        plOtherDataInterface.Token = token;
        item = plOtherDataInterface.getTokenIsValidate();
        if (typeof(item) == "string") {
            item = JSON.parse(item)
        }
    }
    // 
    if (to.meta.auth) {
        if (token != undefined && item.code != 401) {
            next()
        } else if (token == undefined || token != undefined && item.code == 401) {
            router.push({ path: '/' })
        } else {
            next()
        }
    } else {
        next();
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js